module.exports = __webpack_public_path__ + "img/i_10.c8fdf855.png";